import React from "react";

const CheckBlueIcon = () => {
  return (
    <div>
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.335 10a8.333 8.333 0 10-16.667 0 8.333 8.333 0 0016.667 0z"
          stroke="#084784"
          strokeWidth={2.2}
        />
        <path
          d="M10.2 14.166V9.999c0-.392 0-.589-.121-.711-.123-.122-.319-.122-.712-.122M9.992 6.666H10"
          stroke="#084784"
          strokeWidth={2.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default CheckBlueIcon;
